module.exports = __webpack_public_path__ + "fonts/Rubik-Regular.97a0ad4.woff2";